var utils = require("./utils");

$.fn.activeFacets = function () {
  this.each(function () {
    var $self = $(this);
    var $controller = $self.closest(".govuk-main-wrapper");

    var $activeFacetsActionsContainer = $self.find(
      ".js-active-filters-dropdown-container",
    );
    var $filtersActionList = $self.find(".js-active-filters-dropdown");

    var $activeFacetsList = $self.find(".active-filters-list");
    var $clearAllContainer = $self.find(".js-active-filters-clear");
    var $saveAllContainer = $self.find(".js-active-filters-save");
    var $viewAllSavedContainer = $self.find(".js-active-filters-view");

    var $noFacets = $("<li>No filters selected</li>");
    var $moreLink = $(
      '<a href="#">Filter actions <i class="fa fa-caret-down" aria-hidden="true"></a>',
    ).hide();

    var $clearAllLink = $('<a href="#">Clear all filters</a>');
    var $saveAllLink = $('<a href="#">Save active filters</a>');
    var $viewAllSavedLink = $("<a>View all saved filters</a>");
    $viewAllSavedLink.attr(
      "href",
      $viewAllSavedContainer.data("href")
        ? $viewAllSavedContainer.data("href")
        : "#",
    );

    var $defaultViewSavedFilter = $viewAllSavedLink.clone();

    var hasFacets = false;

    // ------------------------------
    // Private methods
    // ------------------------------

    /**
     * @param {boolean} hasSelectedFacets
     * @private
     */
    function _setMessagingVisibility(hasSelectedFacets) {
      if (hasSelectedFacets) {
        $moreLink.show();
        $noFacets.remove();
        $defaultViewSavedFilter.hide();
      } else {
        $moreLink.hide();

        if ($moreLink.data("open")) {
          $moreLink.trigger("click");
        }

        $activeFacetsList.append($noFacets);
        $defaultViewSavedFilter.show();
      }
    }

    // ------------------------------
    // Event listeners
    // ------------------------------
    function clearAll(event) {
      event.preventDefault();

      $controller.trigger("dclg.activeFacets.clearAllActive");
      _setMessagingVisibility(false);
    }

    function resetFilters(event) {
      event.preventDefault();
      $controller.trigger("dclg.activeFacets.resetToInitial");
      _setMessagingVisibility(false);
      $('#search-textfield').trigger("dclg.facets.reset");

      // remove the old session for preloadedMonitor to be able to fully perform reset functionality
      sessionStorage.removeItem("preloadedMonitor");
      applyAll(event);
      $self.find(".reset-all-filters").addClass("visually-hidden");
    }

    function applyAll(event) {
      if(!$(this).prop("disabled")){
    
        event.preventDefault();
        $controller.trigger("dclg.facets.applied");
        $('.apply-all-filters').attr('disabled', true)
          .attr('aria-disabled', true);
      }
    }


    if ($clearAllContainer.length) {
      $clearAllLink.on("click", clearAll);
    } else {
      var $resetLink = $self.find(".reset-all-filters");
      $resetLink.on("click", resetFilters);
      var delta2ClearAllLink = $('.clear-all-filters');
      var delta2ApplyAllLink = $('.apply-all-filters');
      delta2ClearAllLink.on("click", function(event) {
        clearAll(event);  
        $('#search-textfield').val('').trigger('search');
        applyAll(event);
      });
      delta2ApplyAllLink.on("click", function(event) {
        applyAll(event);
      });
    }

    $('.datagrid_clear-filter-link').on("click", function(event){
      $controller.trigger("dclg.activeFacets.clearSelected", event.currentTarget);
    });

    $saveAllLink.on("click", function (event) {
      event.preventDefault();

      var extras = {};
      var $hiddenFields = $saveAllLink
        .closest("form")
        .children('input[type="hidden"]');

      $hiddenFields.each(function () {
        extras[this.name] = this.value;
      });

      $controller.trigger("dclg.activeFacets.saveAllActive", extras);
    });

    $moreLink.data("open", false).on("click", function (e) {
      e.preventDefault();

      var $this = $(this);

      if ($this.data("open")) {
        $filtersActionList.addClass("js-active-filters-dropdown-closed");
        $this.data("open", false);
      } else {
        $filtersActionList.removeClass("js-active-filters-dropdown-closed");
        $this.data("open", true);
      }
    });

    // For handling clicking anywhere on the page, when the dropdown is open
    $("body").bind("click.activefacetsDropdown", closeOpenDropdownEvent);

    $controller.on("dclg.dataGrid.pageChange", function () {
      $("body").unbind("click.activefacetsDropdown", closeOpenDropdownEvent);
    });

    function closeOpenDropdownEvent(event) {
      if (
        event.target !== $moreLink.get(0) &&
        event.target !== $moreLink.children("i").get(0)
      ) {
        $moreLink.data("open", false);
        $filtersActionList.addClass("js-active-filters-dropdown-closed");
      }
    }

    $self.on("dclg.activeFacets.update", function (event, facets) {
      var key;
      hasFacets = false;
      $activeFacetsList.empty();
  
      for (key in facets) {
        if (
          facets.hasOwnProperty(key) &&
          facets[key] &&
          facets[key].activeFacet
        ) {
          hasFacets =
            hasFacets ||
            facets[key].model.some(function (item) {
              return !!item.value;
            });

          facets[key].model.forEach(function (item) {
            var label = item.label;

            if (facets[key].type === "date" || facets[key].type === "deltaDate") {
              label += " " + item.value;
            }

            // The tags require an array object to display activeFacets.
            // We need to make sure we remove any orphend tags
            if (utils.isArray(item.value) && item.value.length === 0) {
              $activeFacetsList.remove('[data-facet-id="' + item.id + '"]');
            } else if (item.value) {
              $activeFacetsList.append(
                '<li data-facet-id="' +
                  item.id +
                  '" data-facet-group-id="' +
                  key +
                  '">' +
                  label +
                  '<a href="#" class="action-right remove-selected-facet"><span class="visually-hidden">Remove</span></a>' +
                  "</li>",
                  "</li>",
              );
            }
          });
        }
      }

      _setMessagingVisibility(hasFacets);
    });

    // ------------------------------
    // Initialisation
    // ------------------------------

    $activeFacetsList.append($noFacets);
    $activeFacetsActionsContainer.prepend($defaultViewSavedFilter);

    $clearAllContainer.append($clearAllLink);
    $saveAllContainer.append($saveAllLink);
    $viewAllSavedContainer.append($viewAllSavedLink);

    $activeFacetsActionsContainer.prepend($moreLink);

    _setMessagingVisibility(false);

    $activeFacetsList.on("click", function (event) {
      var $target = $(event.target);
      if ($target.hasClass("remove-selected-facet")) {
        event.preventDefault();
        $(this)
          .closest(".govuk-main-wrapper")
          .trigger("dclg.activeFacets.removeFacet", $target.parent().data());
      }
    });
  });
};
